import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Sb08FAQ = () => {
  const faqData = [
    {
      question: "Q: What is “SB-08 Generator” in JUNE ?",
      answer: `A: It’s a feature that creates SB-08 forms using just an application number and a list of references. JUNE auto-organizes references into the right sections and applies USPTO-compliant numbering.`,
    },
    {
      question: "Q: What inputs are required to create a SB-08 form ?",
      answer: `A: You’ll need one valid application number and a list of patent references (with country codes, e.g., US1234567, EP1234567).`,
    },
    {
      question: "Q: How many references can I enter in one request ?",
      answer: `A: You can enter up to  500 references for a single application number.`,
    },
    {
      question: "Q: What happens if I skip the country code in my references ?",
      answer: `A: JUNE shows an error in the UI and sends an email: “No data found. Check input and try again.`,
    },
    {
      question: "Q: Can I generate SB-08 form for multiple applications at a time ?",
      answer: `A: No. The system accepts only one application number per request.`,
    },
    {
      question: "Q: What if the number of references I enter exceeds the allowed limit per form ?",
      answer: `A: When the number of references is greater than the maximum allowed, the system automatically creates additional forms.

                • If you provide more than 300 U.S. patents and publications, the first 300 are placed in one form and the remainder in a new form. Numbering restarts from 1 in the new form.

                • If you provide more than 50 foreign references, the first 50 are included in one form and the rest in a new form. Numbering also restarts from 1.`,
    },
    {
      question: "Q: What information is automatically filled in SB-08 form ?",
      answer: `A: JUNE auto-fills the bibliographic header and reference details for US and foreign patents/publications; non-patent literature (NPL) is not auto-filled.`,
    },
    {
      question: "Q: What is included in the output ?",
      answer: `A: The generator provides:

            • Completed SB-08 form(s) in USPTO-compliant PDF format.
            • A summary report showing the total number of references processed and the number of SB-08 forms generated.`,
    },
    {
      question: "Q: Is SB-08 form Editable after Generation ?",
      answer: `A: Yes. Once generated, the SB-08 form can still be edited using software that supports the XFA PDF format, allowing you to make adjustments if needed before submission.`,
    },
    {
      question: "Q: What error messages should I be aware of, and how do I handle them?",
      answer: (
        <>
          <Typography sx={{ mb: 2, whiteSpace: "pre-line" }}>
            A: You may encounter the errors listed below, along with their causes
            and resolutions. Any errors not listed here should be reported
            immediately to the support team.
          </Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Error Message</TableCell>
                <TableCell>Interface</TableCell>
                <TableCell>Cause</TableCell>
                <TableCell>Resolution</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>"No data found. Check input and try again."</TableCell>
                <TableCell>JUNE UI</TableCell>
                <TableCell>Incorrect reference number.</TableCell>
                <TableCell>Verify and re-enter details.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>"Provide valid number with country code."</TableCell>
                <TableCell>Email & Track Task screen</TableCell>
                <TableCell>Country code missing from reference number</TableCell>
                <TableCell>Re-enter references with correct code (e.g., US, EP, JP).</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>"Failed to fetch metadata" or “Missing data”</TableCell>
                <TableCell>Email & Track Task screen</TableCell>
                <TableCell>Some reference details could not be retrieved by our system.</TableCell>
                <TableCell>Check if the reference exists and is valid.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>"Duplicate reference found"</TableCell>
                <TableCell>Email & Track Task screen</TableCell>
                <TableCell>Same reference entered more than once.</TableCell>
                <TableCell>Remove duplicates before submission.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>"Something went wrong."</TableCell>
                <TableCell>JUNE UI & Email</TableCell>
                <TableCell>System error in retrieving metadata.</TableCell>
                <TableCell>Retry submission; contact support if it persists.</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </>
      ),
    },
  ];

  return (
    <Box>
      {faqData.map((item, index) => (
        <Accordion
          key={index}
          defaultExpanded={index === 0}
          sx={{ 
            backgroundColor: "#fff",
            "&.Mui-expanded": {
              margin: 0,
            },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {item.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {typeof item.answer === "string" ? (
              <Typography sx={{ whiteSpace: "pre-line" }}>
                {item.answer}
              </Typography>
            ) : (
              item.answer
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default Sb08FAQ;
